export const loaderSizes = {
    breadcrumbs: {
        width: 230,
        height: 20,
    },
    icon: {
        width: 24,
        height: 24,
    },
    name: {
        width: 230,
        height: 25,
    },
    button: {
        width: 82,
        height: 36,
    },
    text: {
        width: 130,
        height: 20,
    },
    link: {
        width: 180,
        height: 20,
    },
    granularity: {
        width: 145,
        height: 40,
    },
};
